import script from "./SiderMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./SiderMenu.vue?vue&type=script&lang=ts&setup=true"

import "./SiderMenu.vue?vue&type=style&index=0&id=ba69cb16&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba69cb16"]])

export default __exports__